import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  constructor() {}

  public sendEvent(eventName: string, params: {}): void {
    window.gtag && window.gtag('event', eventName, params);
  }
}
